// This file contains alpha data to develop multi-day trail pages before server sends down the needed data
export const tmbSlug = 'trail/france/auvergne-rhone-alpes/tour-du-mont-blanc';

export const tmbSegmentIds = [
  10765523, 10765508, 10765509, 10765510, 10765512, 10765513, 10765514, 10765515, 10765516, 10765517, 10765518, 10765519, 10765520, 10765521, 10765522
];
